// import  { Component } from 'react'
import { Navbar, Nav, Container } from "react-bootstrap";
import Logo from "./SA-logo.png";
import hvacLogo from "./hvac.jpg";
import segurosLogo from "./seguros.png";
import { useTranslation } from "react-i18next";

export const Navigation = () => {
  const { t } = useTranslation("global");

  let logoPath = "";
  const hostName = window.location.hostname.toLowerCase();
  if (hostName === "localhost") {
    logoPath = Logo;
  } else {
    if (hostName.includes("hvac")) {
      logoPath = hvacLogo;
    } else if (hostName.includes("seguros")) {
      logoPath = segurosLogo;
    }
  }

  //const hostName = "hvac";

  return (
    <Navbar style={{ background: "#123157", height: "50px" }}>
      <Container className="navbar-container">
        <Navbar.Brand className="mx-auto">
          <img src={logoPath} alt="site logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              style={{
                color: "white",
                borderLeft: "solid 1px white",
                borderRight: "solid 1px white",
                marginLeft: "5rem",
                fontSize: "12px",
              }}
              href={t("navbar.linkToSite")}
              id="link-back-to-site"
            >
              {t("navbar.backToSite")}
            </Nav.Link>
          </Nav>
          <Nav className="mr-auto">
            <Nav.Link
              style={{ color: "white", fontSize: "12px" }}
              href={t("navbar.callLink")}
              id="link-call"
            >
              {t("navbar.callTop")} <br />{" "}
              <i
                className="fa-solid fa-phone-volume"
                style={{ rotate: "-30deg" }}
              ></i>{" "}
              {t("navbar.callBottom")}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
